import React, {useEffect, useRef, useState} from "react";
import stringUtils from "../../../../utils/string_utils";
import Skeleton from "@mui/material/Skeleton";
import {
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    TableBody,
    Tooltip
} from "@mui/material";
import {
    styleContainerList,
    styleListingOutLine,
    styleTableCellHeader,
} from "../../../../utils/common_style_for_list";
import {commonTaskApiCall} from "../../../controllers/unassigned_controllers";
import CommonColorUtils from "../../../../utils/common_colors";
import CommonTextWithRoundedShape from "../../../../components/CommonTextWithRoundedShape";
import {
    convertTo12Hour,
    localDateFormatWithMonthName,
    localTimeFormat
} from "../../../../utils/date_time_convert_utils";
import No_Record_Found_Page from "../no_record_found_page";
import {showErrorToast} from "../../../../components/toast/error_toast";
import {AssignedTaskModel} from "../../../models/assigned_task_model";
import deleteRedIcon from "../../../../assets/delete_red_icon.svg";
import deleteInactiveIcon from "../../../../assets/delete_inactive_icon.svg";
import DeleteDialogBox from "../../../../components/common_delete_dialog_box";
import {unassignDriverApiCall} from "../../../controllers/assigned_task_controller";
import {showSuccessToast} from "../../../../components/toast/success_toast";
import PickupOrderDetailsScreen from "../order_details_pages/pickup_order_details_screen";
import RtoOrderDetailsScreen from "../order_details_pages/rto_order_details_screen";
import ReturnOrderDetailsScreen from "../order_details_pages/return_order_deatails_screen";
import {ReactComponent as DownloadIcon} from "../../../../assets/download.svg";
import commonColorUtils from "../../../../utils/common_colors";
import downloadTaskApiCall from "./controllers/downloadTaskApiCall";
import StringUtils from "../../../../utils/string_utils";

const textColorMap = {
  "#FFDBDB": CommonColorUtils.primaryErrorDarkColor,
  "#FFF5E5": CommonColorUtils.kSecondaryAlert500,
  "#DFECE9": CommonColorUtils.kPrimeGreenDarker,
};

const AssignedTaskPage = ({selectedHubId, selectedStatus, selectedDriver, countTaskApiCalling,selectedTypes, selectedFilter, selectedIds, selectedVendors, setIsLoading,setCommonCount=()=>{}}) => {
    const [isBusy, setIsBusy] = useState(false);
    const [assignedTaskList, setAssignedTaskList] = useState([]);
    const [assignedFilteredTaskList, setAssignedFilteredTaskList] = useState([]);
    const isFirstRender = useRef(true);
    const [deletePopUpOpen, setDeletePopUpOpen] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState('');
    const [selectedDriverName, setSelectedDriverName] = useState('');
    const [pickUpDialogOpen, setPickUpDialogOpen] = useState(false);
    const [rtoDialogOpen, setRtoDialogOpen] = useState(false);
    const [returnDialogOpen, setReturnDialogOpen] = useState(false);
    const [isDeleteBusy, setIsDeleteBusy] = useState(false);

    //Dialog Handles
    const handleOpenDeleteDialog = async (taskId, driverName) => {
        setSelectedTaskId(taskId);
        setSelectedDriverName(driverName);
        setDeletePopUpOpen(true);
    }
    const handleCloseDeleteDialog = async () => {
        setDeletePopUpOpen(false);
    }

    const handlePickupDialogOpen = () => {
        setPickUpDialogOpen(true);
    }
    const handlePickupDialogClose = () => {
        setPickUpDialogOpen(false);
    }
    const handleRtoDialogOpen = () => {
        setRtoDialogOpen(true);
    }
    const handleRtoDialogClose = () => {
        setRtoDialogOpen(false);
    }

    const handleReturnDialogOpen = () => {
        setReturnDialogOpen(true);
    }
    const handleReturnDialogClose = () => {
        setReturnDialogOpen(false);
    }

    //columns
    const columns = [
        { id: "clientLocation", label: stringUtils.pickupLocation, width: "150px" },
        { id: "address", label: stringUtils.pickupAddress, width: "150px" },
        {id: "vendorName", label: stringUtils.vendorName, width: "150px"},
        // { id: "destinationHubLocationName", label: stringUtils.destinationHub, width: "150px" },
        { id: "visitTime", label: stringUtils.visitTime, width: "80px" },
        { id: "taskId", label: stringUtils.taskId, width: "100px" },
        { id: "tasksType", label: stringUtils.tasks, width: "100px" },
        { id: "createdDate", label: stringUtils.createdOn, width: "120px" },
        {id:"taskAge", label: stringUtils.taskAge.toUpperCase(), width: "80px"},
        { id: "status", label: stringUtils.status.toUpperCase(), width: "80px" },
        { id: "action", label: stringUtils.action.toUpperCase(), width: "80px" },
    ];

    const assignedTaskApiCalling = async () => {
        try {
            setIsBusy(true);
            const response = await commonTaskApiCall('assigned',selectedTypes,selectedFilter,selectedIds,selectedVendors);
            const assignedTaskModel = AssignedTaskModel.fromJSON(response);
             setCommonCount((prevCount) => ({
                    ...prevCount,
                    assignedCount: response?.task_count||0,
                }));
            setAssignedTaskList(assignedTaskModel.taskLocation);
            filterAssignedTaskList(assignedTaskModel.taskLocation);
        } catch (e) {
            showErrorToast('Something went wrong', e);
            setAssignedTaskList([]);
        } finally {
            setIsBusy(false);
        }
    }
    const styleBlock = {
        display: "flex",
        alignItems: "left", flexDirection: "column", width: `125px`, whiteSpace: "normal", wordWrap: "break-word",
    }
    const tableCellSkeleton = (
        <Skeleton variant="rectangular" width={100} height={30}/>
    );
  const filterAssignedTaskList = (list = assignedTaskList) => {
  let filteredList = list;
        if (selectedDriver !== 'all@gmail.com') {
            filteredList = filteredList.filter(
                (taskLocation) =>
                    taskLocation?.driverEmail?.toLowerCase() === selectedDriver.toLowerCase()
            );
        }
        if (selectedStatus !== 'All') {
            filteredList = filteredList.map((taskLocation) => ({
                ...taskLocation,
                tasks: taskLocation.tasks.filter((task) => task.status.toLowerCase() === selectedStatus.toLowerCase()),
            })).filter(taskLocation => taskLocation.tasks.length > 0);
        }
        setAssignedFilteredTaskList(filteredList);
        setCommonCount((prevCount) => ({
            ...prevCount,
            assignedCount: filteredList.reduce((total, taskLocation) => total + taskLocation?.tasks.length, 0) || 0,
        }));
    }

    const unassignedDriverApiCalling = async () => {
        try {
            setIsDeleteBusy(true);
            const response = await unassignDriverApiCall(selectedTaskId);
            if (response) {
                await handleCloseDeleteDialog()
                showSuccessToast(response.message);
                assignedTaskApiCalling();
                countTaskApiCalling();
                filterAssignedTaskList();
            }
        } catch (e) {
            const errorMessage = e.message.replaceAll("Error:", "");
            showErrorToast(errorMessage);
        } finally {
            setIsDeleteBusy(false);
        }
    }
    const openOrderDetailsPage = (orderType, taskId, driverName) => {
        setSelectedTaskId(taskId);
        setSelectedDriverName(driverName);
        if (orderType.toLowerCase() === 'pick up') {
            handlePickupDialogOpen();
        } else if (orderType.toLowerCase() === 'rto') {
            handleRtoDialogOpen()
        } else if (orderType.toLowerCase() === 'return') {
            handleReturnDialogOpen()
        }
    }

    const [downloadLoading, setDownloadLoading] = useState(false);
    const handleDownloadTask = async (taskId) => {

    try {
        setDownloadLoading(true);
        showSuccessToast(`Downloading task ${taskId}…`);
        const res = await downloadTaskApiCall(taskId);
        showSuccessToast(StringUtils.downloadSuccess);
        setDownloadLoading(false);
    } catch (err) {
        showErrorToast(StringUtils.downloadFailed);
        setDownloadLoading(false);
    }
};


    useEffect(() => {
        assignedTaskApiCalling();
    }, [selectedHubId, selectedTypes, selectedIds, selectedVendors]);

    useEffect(() => {
        filterAssignedTaskList();
    }, [selectedStatus, selectedDriver]);

    useEffect(() => {
    setIsLoading(isBusy);
    }, [isBusy]);

    return (
        <>
            {!isBusy && assignedFilteredTaskList.length === 0 ? (
                <No_Record_Found_Page noRecordTitle={stringUtils.noAssignedTasks}
                                      noRecordDescription={stringUtils.driverAssignmentIsNotYetDone}/>
            ) : (
                <>
                    {isBusy ? (<>
                        {Array.from({length: 20}).map((_, index) => (
                            <div>
                                <Skeleton
                                    key={index}
                                    variant="rectangular"
                                    width={'98%'}
                                    height={80}
                                    style={{
                                        margin: '15px 20px', flex: 1,
                                        overflowX: 'auto',
                                    }} // Optional styling for spacing
                                />
                            </div>
                        ))}
                    </>) : (
                        <div style={{overflowY: 'auto',...(!localStorage.getItem('isFromHostApplication') ?{height: 'calc(80vh)'}:{height: 'calc(75vh)'})}}>
                            {
                                assignedFilteredTaskList.map((taskLocation, index) => (
                                    <>
                                        <div style={{
                                            border: `1px solid ${CommonColorUtils.primaryGrey300}`,
                                            margin: '20px 15px',
                                            borderRadius: "16px",
                                        }}>
                                            <div style={{display: "flex", alignItems: "center", margin: '20px'}}>
                                                <img
                                                    src={taskLocation.driverImageUrl.includes('default.png') || taskLocation.driverImageUrl.trim() === '' ? 'https://upload.wikimedia.org/wikipedia/commons/c/cd/Portrait_Placeholder_Square.png' : taskLocation.driverImageUrl}
                                                    style={{width: '48px', height: '48px', marginRight: '10px'}}/>
                                                <div>
                                                    <h4 style={{
                                                        margin: '0',
                                                        fontSize: '16px'
                                                    }}>{taskLocation.driverName}</h4>
                                                    <p style={{
                                                        margin: '4px 0 0 0',
                                                        color: CommonColorUtils.primaryGrey600,
                                                        fontSize: '14px'
                                                    }}>
                                                        {stringUtils.assignedLocations}: {taskLocation.tasks.length}
                                                    </p>
                                                </div>
                                            </div>
                                            <div style={{
                                                borderTopLeftRadius: "16px",
                                                borderRadius: "16px",
                                                border: `1px solid ${CommonColorUtils.primaryGrey300}`,
                                                height: '80%',
                                                overflow: 'auto',
                                                display: 'flex',
                                            }}>

                                                <TableContainer style={styleContainerList}>
                                                    <Table style={{tableLayout: 'fixed'}}>
                                                        <TableHead>
                                                            <TableRow>
                                                                {columns.map((colum) => (
                                                                    <TableCell align={'left'} style={{
                                                                        width:`${colum.width}`,
                                                                        height: "43px",
                                                                        backgroundColor: CommonColorUtils.primaryGrey300,
                                                                        padding: "0px",
                                                                        paddingLeft: colum.id === 'taskType' ? '0px' : "20px",
                                                                        paddingRight: "20px",
                                                                        position: "sticky",
                                                                        top: 0,
                                                                        zIndex: 100,
                                                                        fontFamily: "Inter, Arial, sans-serif",
                                                                        color: commonColorUtils.primaryGrey600,
                                                                        fontWeight: "600",
                                                                        fontSize: "12px",
                                                                    }}>
                                                                        {colum.label}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                    <TableBody>
                                                        {
                                                            taskLocation.tasks.map((row, rowIndex) => (
                                                                <>
                                                                    <TableRow
                                                                        key={rowIndex}
                                                                        style={{
                                                                            backgroundColor: CommonColorUtils.kPrimaryPureWhite,
                                                                        }}
                                                                    >
                                                                        {columns.map((column, columnIndex) => (
                                                                            <TableCell
                                                                                key={`${rowIndex}-${columnIndex}`}
                                                                                align={'left'}
                                                                                style={{
                                                                                    width: `${column.width}`,
                                                                                    padding: "0px",
                                                                                    paddingLeft: column.id === 'taskType' ? '0px' : "20px",
                                                                                    paddingRight: "20px",
                                                                                    height: "54px",
                                                                                    borderBottom: `1px solid ${CommonColorUtils.primaryGrey300}`,
                                                                                    fontFamily: "Inter, Arial, sans-serif",
                                                                                    color: CommonColorUtils.primaryGrey700,
                                                                                    fontWeight:
                                                                                        column.id === "clientLocation" || column.id === "status" ? 600 : 400,
                                                                                    fontSize: "14px",
                                                                                }}
                                                                            >
                                                                                {(() => {
                                                                                    if (column.id === "clientLocation" || column.id === 'address' || column.id === "destinationHubLocationName") {
                                                                                        return <div
                                                                                            style={styleBlock}>{row[column.id]}</div>
                                                                                    }
                                                                                    if (column.id === "tasksType") {
                                                                                        let colorText = CommonColorUtils.kPrimeGreenDarker;
                                                                                        let colorBG = CommonColorUtils.kPrimeGreenDarkShade;
                                                                                        if (row[column.id][0].type.toLowerCase() === 'return') {
                                                                                            colorBG = CommonColorUtils.kPrimePurpleLightShade;
                                                                                            colorText = CommonColorUtils.kPrimePurpleDarkShade;
                                                                                        }
                                                                                        if (row[column.id][0].type.toLowerCase() === 'rto') {
                                                                                            colorBG = CommonColorUtils.krtoBackgroundColor;
                                                                                            colorText = CommonColorUtils.krtoTextColor;
                                                                                        }
                                                                                        if (row['status'] === 'CANCELLED') {
                                                                                            colorBG = CommonColorUtils.primaryErrorLightRed;
                                                                                            colorText = CommonColorUtils.primaryErrorDarkColor;
                                                                                        }
                                                                                        return (
                                                                                            <>
                                                                                                <div
                                                                                                    onClick={() => openOrderDetailsPage(row[column.id][0].type, row['taskId'], taskLocation.driverName)}
                                                                                                    style={{
                                                                                                        padding: '0px 0px',
                                                                                                        marginRight: '20px',
                                                                                                        cursor: 'pointer'
                                                                                                    }}>
                                                                                                    <CommonTextWithRoundedShape
                                                                                                        text={`${row[column.id][0].type} (${row[column.id][0].count})`}
                                                                                                        backgroundColor={
                                                                                                            colorBG
                                                                                                        }
                                                                                                        color={
                                                                                                            colorText
                                                                                                        }
                                                                                                        verticalPadding={0}

                                                                                                        leftMarging={0}

                                                                                                    />
                                                                                                </div>
                                                                                            </>
                                                                                        );
                                                                                    } else if (column.id === 'visitTime') {
                                                                                        return convertTo12Hour(row[column.id]);
                                                                                    } else if (column.id === 'createdDate') {
                                                                                        return `${localDateFormatWithMonthName(row[column.id])} at ${localTimeFormat(row[column.id])}`;
                                                                                    } else if (column.id === 'action') {
                                                                                        return (
                                                                                            <div style={{display: 'flex', gap: '10px'}}><Tooltip title="Download">
                                                                                                                        <DownloadIcon
                                                                                                                                onClick={!downloadLoading ? () => handleDownloadTask(row.taskId) : undefined}
                                                                                                                                style={{
                                                                                                                                    cursor: downloadLoading ? "not-allowed" : "pointer",
                                                                                                                                    opacity: downloadLoading ? 0.4 : 1,
                                                                                                                                    pointerEvents: downloadLoading ? "none" : "auto"
                                                                                                                                }}
                                                                                                                            />
                                                                                                                        </Tooltip>
                                                                                               
                                                                                                {row['status'].toLowerCase() === 'assigned' ? (
                                                                                                <div
                                                                                                    onClick={() => handleOpenDeleteDialog(row['taskId'], taskLocation.driverName)}
                                                                                                    style={{cursor: 'pointer'}}>
                                                                                                    <img
                                                                                                        src={deleteRedIcon}
                                                                                                        alt="Delete Img"
                                                                                                    />
                                                                                                </div>
                                                                                            ) : (
                                                                                                <img
                                                                                                    src={deleteInactiveIcon}
                                                                                                    alt="Delete Img"
                                                                                                />
                                                                                            )}
                                                                                            </div>
                                                                                        );

                                                                                    } else if (column.id === 'status') {
                                                                                        let colorText = CommonColorUtils.kSecondaryAlert500;
                                                                                        if (row[column.id].toLowerCase() === 'completed') {
                                                                                            colorText = CommonColorUtils.primarySuccessDarkGreen
                                                                                        }
                                                                                        if (row[column.id].toLowerCase() === 'work in progress') {
                                                                                            colorText = CommonColorUtils.primaryMainBlue
                                                                                        }
                                                                                        if (row[column.id].toLowerCase() === 'cancelled') {
                                                                                            colorText = CommonColorUtils.primaryErrorDarkColor
                                                                                        }

                                                                                        return <span
                                                                                            style={{color: colorText}}>{row[column.id]}</span>
                                                                                    } else if (column.id === 'taskAge') {
                                                                                        return <CommonTextWithRoundedShape
                                                                                            text={`${row[column.id]?.days || 0} ${stringUtils.days}`}
                                                                                            backgroundColor={row[column.id]?.color_code}
                                                                                            color={textColorMap[row[column.id]?.color_code] ?? CommonColorUtils.primaryGrey700}
                                                                                            fontWeight={600}
                                                                                            verticalPadding={0}
                                                                                            leftMarging={0}
                                                                                        />
                                                                                     } else {
                                                                                        return row[column.id];
                                                                                    }
                                                                                })()}
                                                                            </TableCell>
                                                                        ))}
                                                                    </TableRow>
                                                                </>
                                                            ))
                                                        }
                                                    </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                        </div>
                                    </>
                                ))
                            }
                        </div>
                    )}
                </>
            )}
            <DeleteDialogBox open={deletePopUpOpen} onClose={handleCloseDeleteDialog}
                             titleText={stringUtils.unassignedTaskFrom}
                             contentText={stringUtils.areYouSureYouWantToContinue}
                             buttonText={isDeleteBusy?stringUtils.unassigning:stringUtils.unassign}
                             highlightedContentText={stringUtils.thisActionWillMoveTheOrderToUnassignedTask}
                             callDeleteButton={unassignedDriverApiCalling}
                             isDeleteBusy={isDeleteBusy}/>
            <PickupOrderDetailsScreen open={pickUpDialogOpen} onClose={handlePickupDialogClose}
                                      navigatedFrom={stringUtils.assignedTasks} taskId={selectedTaskId}
                                      driverName={selectedDriverName}/>
            <RtoOrderDetailsScreen open={rtoDialogOpen} onClose={handleRtoDialogClose}
                                   navigatedFrom={stringUtils.assignedTasks} taskId={selectedTaskId}
                                   driverName={selectedDriverName}/>
            <ReturnOrderDetailsScreen open={returnDialogOpen} onClose={handleReturnDialogClose}
                                      navigatedFrom={stringUtils.assignedTasks} taskId={selectedTaskId}
                                      driverName={selectedDriverName}/>
        </>
    )
}

export default AssignedTaskPage;